module.exports = __webpack_public_path__ + "img/assynco-home.70b3830f.png";